import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import lookups from '@/assets/json/clientLookups.json'

const checkInvestigationCancelFines = async () => {
  checkIfVirtualSponsorByUniNumOrFileNumber()
  const formStore = useFormStore()
  const { serviceTransactionId, administrativeRegionId } = formStore.extraMap
  const {
    ServiceTransactions: {
      finesForCancelLeavePermitForExemption,
      cancelLeavePermitForExemptionAndCreateNewOne
    }
  } = lookups
  if (serviceTransactionId == cancelLeavePermitForExemptionAndCreateNewOne) {
    const {
      leavePermitNumberDept = '',
      leavePermitNumberSerial = '',
      leavePermitNumberYear = ''
    } = formStore.form.values
    if (!leavePermitNumberDept || !leavePermitNumberSerial || !leavePermitNumberYear) return
    const response = await apiHelperService.post(
      '/api/user/checkIfVirtualSponsorByUniNumOrFileNumber',
      {
        serviceTransactionId: finesForCancelLeavePermitForExemption, // Cancel Leave Permit Fines Service Id (624).
        departmentCode: leavePermitNumberDept,
        sequenceNumber: leavePermitNumberSerial,
        serviceYear: leavePermitNumberYear,
        administrativeRegionId
      }
    )
    if (!response) return
    const {
      finesAmount = '',
      overstayDays = '',
      legalExitDate = '',
      finesCalculationDate = ''
    } = response
    formStore.draft.request = {
      ...formStore.draft.request,
      finesAmount,
      overstayDays,
      legalExitDate,
      finesCalculationDate
    }
    formStore.extraMap = {
      ...formStore.extraMap,
      showFinesWarningMessage: finesAmount > 0
    }
  } else {
    const {
      departmentCode = '',
      serviceCode = '',
      sequenceNumber = '',
      serviceYear = '',
      personUnifiedNumber = ''
    } = formStore.form.values
    if (
      !departmentCode ||
      !serviceCode ||
      !sequenceNumber ||
      !serviceYear ||
      !personUnifiedNumber
    ) {
      return
    }
    const response = await apiHelperService.get('/api/bulkRequest/violatedFiles', {
      params: {
        personUnifiedNumber,
        fileDepartmentCode: departmentCode,
        fileYear: serviceYear,
        fileTypeCode: serviceCode,
        fileSequenceNumber: sequenceNumber,
        serviceTransId: serviceTransactionId,
        fileModuleId: 1
      }
    })
    if (!response) return
    formStore.extraMap.showFinesWarningMessage = false
    if (response.length > 0) {
      formStore.extraMap.showFinesWarningMessage = true
    }
  }
}
const checkIfVirtualSponsorByUniNumOrFileNumber = async () => {
  const formStore = useFormStore()
  const {
    personUnifiedNumber = '',
    departmentCode = '',
    serviceYear = '',
    serviceCode = '',
    sequenceNumber = ''
  } = formStore.form.values
  const { serviceTransactionId } = formStore.extraMap
  const {
    ServiceTransactions: { cancelLeavePermit }
  } = lookups
  if (
    serviceTransactionId != cancelLeavePermit ||
    (!personUnifiedNumber && !departmentCode && !serviceYear && !serviceCode && !sequenceNumber)
  ) {
    return
  }

  const params = {
    unifiedNumber: personUnifiedNumber,
    moduleId: 1,
    ...(departmentCode && { departmentCode }),
    ...(serviceYear && { resiYear: serviceYear }),
    ...(serviceCode && { resiServiceCode: serviceCode }),
    ...(sequenceNumber && { resiSequenceNumber: sequenceNumber })
  }

  const response = await apiHelperService.get(
    '/api/user/checkIfVirtualSponsorByUniNumOrFileNumber',
    {
      params
    }
  )
  if (!response) return
  formStore.extraMap.hideSponsorInformation = false
  if (response.isVirtualSponsor) {
    formStore.extraMap.hideSponsorInformation = true
  }
}
const checkLeavePermitNumber = () => {
  checkInvestigationCancelFines()
}
const checkPersonUnifiedNumber = (params) => {
  checkPersonIdentityNumber(params)

  checkInvestigationCancelFines()
}
const checkPersonIdentityNumber = async (params) => {
  const formStore = useFormStore()
  const { identityNumber = '', personUnifiedNumber = '' } = formStore.form.values
  if (!identityNumber && !personUnifiedNumber) return
  const res = await apiHelperService.get(
    '/api/typingCenter/citizenServices/draft/usersInfoByIdentityNumberOrUnifiedNumber',
    { params }
  )
  if (!res) return
  const { unifiedNumber, identityCardNumber } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    personUnifiedNumber: unifiedNumber || personUnifiedNumber,
    identityNumber: identityCardNumber || identityNumber
  }
}
export default function () {
  return {
    checkInvestigationCancelFines,
    checkLeavePermitNumber,
    checkPersonUnifiedNumber,
    checkPersonIdentityNumber
  }
}
